import Poll from './Polls';
import ViewPoll from './ViewPoll';
import AddManualVotes from './AddManualVotes'

export const POLLS_ROUTE = "/polls";
export const ADD_POLL_ROUTE = POLLS_ROUTE + "/new";
export const VIEW_POLL_ROUTE = POLLS_ROUTE + "/view";
export const ADD_MANUAL_VOTE_ROUTE = POLLS_ROUTE + '/addmanualvotes'

export const routes = [
    {
        path: POLLS_ROUTE,
        component: Poll,
        exact: true
    },
    {
        path: ADD_POLL_ROUTE,
        component: ViewPoll,
        exact: true
    },
    {
        path: VIEW_POLL_ROUTE + "/:id",
        component: ViewPoll,
        exact: true
    },
    {
        path: ADD_MANUAL_VOTE_ROUTE + "/:id",
        component: AddManualVotes,
        exact: true
    }
]


